<template>
  <div class="scroll-wrapper">
    <ul class="message-section">
      <li class="message-item" v-for="(item,index) in question">
        <p class="time" v-if="item.time">
          <span>{{item.time.substring(0,16)}}</span>
        </p>
        <dl class="message-row">
          <dt class="message-role" :class="{'teacher':item.listtype=='1','student':item.listtype=='2'}">
            <template v-if="item.listtype=='1'">老师</template>
            <template v-else>学生</template>
          </dt>
          <template v-if="item.infotype=='1'">
            <pre class="message-text">{{decodeURIComponent(item.text)}}</pre>
          </template>
          <template v-if="item.infotype=='2'">
            <span v-viewer="options">
              <img class='showimg' :src="computeUrl(item.image)" alt="img" width="100" height="100">
            </span>
          </template>
          <div v-if="item.infotype=='3'" class="audio-container">
            <audio ref="audio" :data-value="item.mp3">
              <source ref="source" :src="audioprefix+item.mp3" type="audio/mp3">
            </audio><span class="audio_default"  @click="play_audio" :data-value="item.mp3"></span>
            <span class="audio-time">{{item.mp3sec}}"</span>
          </div>
          <div v-if="item.infotype=='4'" class="file-container">
            <section class="file-top">
              <img class="fileicon" src="./fileicon.png" alt="icon" width="46" height="46">
              <section class="top-right">
                <p class="title">{{decodeURIComponent(item.filename)}}</p>
                <p class="send-text">已发送</p>
              </section>
            </section>
            <section class="file-bottom">
              <a  class="download" :download="item.filename" :href="audioprefix+item.filepath">下载</a>
            </section>
          </div>
          <template v-if="answernum=='0'">
            <span class="message-delete" @click="deletemessage(index)"></span>
          </template>
        </dl>

      </li>
      <li class="message-item" v-for="(item,index) in reply">
        <p class="time" v-if="item.time">
          <span>{{item.time.substring(0,16)}}</span>
        </p>
        <dl class="message-row">
          <dt class="message-role" :class="{'teacher':item.listtype=='1','student':item.listtype=='2'}">
            <template v-if="item.listtype=='1'">老师</template>
            <template v-else>学生</template>
          </dt>
          <template v-if="item.infotype=='1'">
            <pre class="message-text">{{decodeURIComponent(item.text)}}</pre>
          </template>
          <template v-if="item.infotype=='2'">
            <span v-viewer="options">
              <img class='showimg' :src="computeUrl(item.image)" alt="img" width="100" height="100">
            </span>
          </template>
          <div v-if="item.infotype=='3'" class="audio-container">
            <audio ref="audio" :data-value="item.mp3">
              <source ref="source" :src="audioprefix+item.mp3" type="audio/mp3">
            </audio><span class="audio_default"  @click="play_audio" :data-value="item.mp3"></span>
            <span class="audio-time">{{item.mp3sec}}"</span>
          </div>
          <div v-if="item.infotype=='4'" class="file-container">
            <section class="file-top">
              <img class="fileicon" src="./fileicon.png" alt="icon" width="46" height="46">
              <section class="top-right">
                <p class="title">{{decodeURIComponent(item.filename)}}</p>
                <p class="send-text">已发送</p>
              </section>
            </section>
            <section class="file-bottom">
              <a  class="download" :download="item.filename" :href="audioprefix+item.filepath">下载</a>
            </section>
          </div>
        </dl>
      </li>
      <li class="message-item" v-for="(item,index) in temp">
        <p class="time" v-if="item.time">
          <span>{{item.time.substring(0,16)}}</span>
        </p>
        <dl class="message-row">
          <dt class="message-role" :class="{'teacher':item.listtype=='1','student':item.listtype=='2'}">
            <template v-if="item.listtype=='1'">老师</template>
            <template v-else>学生</template>
          </dt>
          <template v-if="item.infotype=='1'">
            <pre class="message-text">{{decodeURIComponent(item.text)}}</pre>
          </template>
          <template v-if="item.infotype=='2'">
            <span v-viewer="options">
              <img class='showimg' :src="computeUrl(item.image)" alt="img" width="100" height="100">
            </span>
          </template>
          <div v-if="item.infotype=='3'" class="audio-container">
            <audio ref="audio" :data-value="item.mp3">
              <source ref="source" :src="audioprefix+item.mp3" type="audio/mp3">
            </audio><span class="audio_default"  @click="play_audio" :data-value="item.mp3"></span>
            <span class="audio-time">{{item.mp3sec}}"</span>
          </div>
          <div v-if="item.infotype=='4'" class="file-container">
            <section class="file-top">
              <img class="fileicon" src="./fileicon.png" alt="icon" width="46" height="46">
              <section class="top-right">
                <p class="title">{{decodeURIComponent(item.filename)}}</p>
                <p class="send-text">已发送</p>
              </section>
            </section>
            <section class="file-bottom">
              <a  class="download" :download="item.filename" :href="audioprefix+item.filepath">下载</a>
            </section>
          </div>
          <template v-if="answernum>'0'">
            <span class="message-delete" @click="deletemessage(index)"></span>
          </template>
        </dl>

      </li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
  import {imgprefix,audioprefix} from '@/common/js/globalvalue'

  export default {
    props: {
      question: {
        type: Array
      },
      reply: {
        type: Array
      },
      temp: {
        type: Array
      },
      answernum:{
        type:String
      }
    },
    data() {
      return {
        message: [
          {text: "这", listtype: "1", infotype: "1"}
        ],
        options: {
          "inline": false,
          "button": true,
          "navbar": false,
          "title": false,
          "toolbar": true,
          "tooltip": false,
          "movable": true,
          "zoomable": true,
          "rotatable": true,
          "scalable": false,
          "transition": true,
          "fullscreen": true,
          "keyboard": false
        },
        nowPlayId:'',
        audioprefix:audioprefix,
      }
    },
    methods: {
      deletemessage(index) {
        this.$emit('deletemessage', index);
      },
      computeUrl(url) {
        return imgprefix + url;
      },
      play_audio(e) {
        let value=e.target.getAttribute('data-value');

        let audio=this.$refs.audio;
        audio.forEach((item)=>{
          //遍历audio元素，对于当前点击的audio，根据播放状态播放或者暂停
          if(item.getAttribute('data-value')==value){
            if(!item.paused){
              item.pause();
              item.removeEventListener('ended',null,false);
              item.nextElementSibling.className='audio_default'
            }else{
              item.play();
              item.nextElementSibling.className='audio_default audio_play'
              this.nowPlayId=value;
              item.addEventListener('ended', function () {
                item.nextElementSibling.className='audio_default'
              }, false);
            }
          }
          //对于不是当前点击的audio，则结束播放
          else{
            item.pause();
            item.removeEventListener('ended',null,false);
            item.nextElementSibling.className='audio_default'
          }
        })
      }

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .scroll-wrapper {
    position: absolute;
    padding-left: 50px;
    top: 66px;
    right: 0;
    bottom: 150px;
    left: 0;
    background: #f9f8fc
    overflow: auto
    .message-section {
      .message-item {
        margin-bottom: 25px;
        .time {
          height: 20px;
          line-height: 20px;
          padding: 15px 0 20px;
          text-align: center;
          font-size: 14px;
          color: #a5a5a5;
        }
        .message-row {
          .message-role {
            float: left;
            margin: 0 10px 0 0;
            width: 52px;
            height: 52px;
            line-height: 52px;
            text-align: center;
            font-size: 14px;
            color: #fff;
            border-radius: 26px;
            &.student {
              background: #ff6700
            }
            &.teacher {
              background: #3399ff
            }
          }
          .message-text {
            white-space: normal;
            display: inline-block;
            padding: 15px 20px;
            max-width: 78%;
            background-color: #fff;
            border-radius: 6px;
            font-size: 14px;
            color: #333;
            line-height: 22px;
          }
          .audio-container {
            display: inline-block;
            padding-left: 20px;
            height: 52px;
            width: 180px;
            border-radius: 6px;
            background: #fff;
            .audio-time {
              margin-left: 10px;
              font-size: 15px;
              line-height: 52px;
              color: #333;
            }
            .audio_default {
              position: relative
              top: 2px;
              display: inline-block;
              width: 22px;
              height: 22px;
              background-image: url("./audio_default_left.png");
              cursor: pointer
              &.audio_play {
                background-image: url("./audio_play_left.png");
                animation: play steps(3, start) 1s infinite;
                -webkit-animation: play steps(3, start) 1s infinite;
                @-webkit-keyframes play {
                  100% {
                    background-position: -90px 0
                  }
                }
              }
            }

          }
          .message-delete {
            margin: 15px 0 0 10px;
            display: inline-block;
            width: 20px;
            height: 20px;
            background: url('./delete.png') no-repeat center / 20px 20px;
            border-radius: 10px;
            vertical-align: top
            cursor: pointer;
          }
          .file-container{
            display: inline-block;
            height: 94px;
            width: 245px;
            border-radius: 6px;
            background: #fff;
            .file-top{
              height:66px;
              padding:10px;
              box-sizing :border-box
              .fileicon{
                float:left;
              }
              .top-right{
                margin-left:10px;
                float:left;
                width:169px;
                .title{
                  height:19px;
                  font-size:14px;
                  color:#333;
                  white-space: nowrap
                  overflow: hidden
                  text-overflow: ellipsis
                }
                .send-text{
                  margin-top:10px;
                  font-size:12px;
                  color:#888;
                  height:16px;
                }
              }
            }
            .file-bottom{
              border-top:1px solid #e9e9e9;
              position:relative;
              .download{
                position:absolute
                font-size:12px;
                color:#3399ff;
                top:8px;
                right:18px;
                cursor:pointer
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homework/tscrollwrapper.vue